import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { CorrectYeKeService } from "projects/sepidz-web-framework/src/lib/services";
import { SelectorService } from "../base/selector.service";
import { formatNumber } from "@angular/common";
import { PersianService } from "projects/sepidz-web-framework/src/lib/services/persian.service";
import { InputDataModel } from "./inputdata.model";
import { isNullOrUndefined } from "projects/persian-date-picker/src/public-api";
import { Validators } from "@angular/forms";

@Component({
  selector: "ssg-input",
  styleUrls: ["input.component.scss"],
  templateUrl: "input.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent extends BaseControlComponent<string> {
  @Input() hideBorder: boolean = false;
  @Input() isshow: boolean;
  @Input() accept: string;
  @Input() isGetPath: boolean;
  @Input() labletop: boolean;

  inputFocus: boolean;
  orignalTextType: string = "text";
  externalicon: string;
  isFinish: boolean;
  inputDataModel: InputDataModel = new InputDataModel();
  // maxValidatorIsAdded = false;
  private _isPassword = false;
  ngAfterViewChecked() {
    const ctrl = this.group?.controls[this.name];
    if (this.isNumberOnly && this.name && ctrl && ctrl?.value < 0) {
      ctrl.setValue(ctrl?.value * -1);
    }
    if (this.name && ctrl && ctrl.value !== undefined && ctrl.value !== null) {
      this.isshow = true;
    }
    if (this.isReadOnly) {
      this.id = this.name;
    }
    if (!ctrl?.value && (this.inputDataModel.FormControlValue === "" || !this.inputDataModel.FormControlValue)) {
      this.inputDataModel.FormControlValue = ctrl?.value === null ? null : undefined;
    }
    if (!this.inputDataModel.FormControlValue && ctrl?.value === "") {
      this.inputDataModel.FormControlValue = "";
    }
    if (ctrl?.value === 0 && !this.inputDataModel.FormControlValue) this.inputDataModel.FormControlValue = 0;
    if (`${ctrl?.value}` !== `${this.inputDataModel.FormControlValue}`) {
      this.inputValueCustomizeChange();
    }
  }

  show() {
    this.isshow = !this.isshow;
  }
  focusFunction($event) {
    const ctrl = this.f[this.name];
    if (this.max > 0) {
      if (this.textType !== "text" || this.isNumberOnly || this.isDecimal || this.isFloat /*&& !this.maxValidatorIsAdded*/) {
        ctrl.addValidators(Validators.max(this.max));
        // this.maxValidatorIsAdded = true;
      } //if (!this.maxValidatorIsAdded) {
      else ctrl.addValidators(Validators.maxLength(this.max));
      // this.maxValidatorIsAdded = true;
      // }
    }
    if (this.patternKey && !ctrl.hasValidator(Validators.pattern(this.patternKey))) {
      ctrl.addValidators([Validators.pattern(this.patternKey)]);
    }
    this.isshow = true;
    this.inputFocus = true;
    const finItem = <HTMLInputElement>document.getElementById(this.name);
    if ($event && finItem) {
      finItem.focus();
      if (this.textType === "number") {
        finItem.select();
      }
    }
    this.group?.controls[this.name]?.markAsUntouched();
    this.focus.emit();
  }
  focusOutFunction($event) {
    if (!this.group?.controls[this.name]?.value || this.group?.controls[this.name]?.value === "" || !this.inputDataModel.currentValue) {
      this.isshow = false;
      this.inputFocus = false;
    }
    this.group?.controls[this.name]?.markAsTouched();
    this.focusout.emit(this.group?.controls[this.name]?.value);
  }
  @Input() hasClear: boolean;
  @Input() isReadOnly: boolean;
  @Input() class: string;
  @Input() hint: string;
  @Input() icon: string;
  @Input() righticon: string;
  @Input() autocomplete: string = "off";
  @Input() withComma: boolean = false;
  @Input() inputMask: string;
  @Input() isNumberOnly: boolean;
  @Input() isFloat: boolean;
  @Input() inputMode: any;
  @Output() iconClick = new EventEmitter<any>();
  @Output() focusout = new EventEmitter<any>();
  @Output() rightIconClick = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();
  @Output() focus = new EventEmitter<any>();
  @Output() externalIconClick = new EventEmitter<any>();
  @Output() oninput = new EventEmitter<any>();
  @Output() change = new EventEmitter<any>();
  @ViewChild("inp") inpElement: ElementRef;
  constructor(protected cd: ChangeDetectorRef, protected selectorService: SelectorService, private persianService: PersianService) {
    super(selectorService, cd);

    if (!this.autocomplete) {
      this.autocomplete = "off";
    }
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.textType === "password") {
      this._isPassword = true;
      this.icon = "icon-visibility-o";
    }
    if (!this.isFloat) this.isFloat = this.selectorService.getIsFloat(this.name);
  }
  testHasValue(): boolean {
    if (this.isshow) return true;
    if (this.name && this.group?.controls) {
      if (this.isNumberOnly && this.group?.controls[this.name]?.value < 0) {
        this.group?.controls[this.name].setValue(this.group?.controls[this.name].value * -1);
      }
      if (
        this.group?.controls[this.name]?.value !== "" &&
        this.inputDataModel?.currentValue &&
        this.group?.controls[this.name]?.value !== undefined &&
        this.group?.controls[this.name]?.value !== null
      ) {
        this.isshow = true;
      } else if (this.isReadOnly) {
        this.id = this.name;
      }
      if (this.isReadOnly) {
        this.id = this.name;
      }
    }
    return true;
  }
  getInputValue(value, isInputValue?: boolean) {
    if (
      !this.required &&
      !this.isNullable &&
      !value &&
      value !== 0 &&
      !this.group?.controls[this.name]?.value &&
      this.group?.controls[this.name]?.value !== 0 &&
      (this.textType === "number" || this.textType === "currency")
    ) {
      this.inputDataModel.FormControlValue = "0";
      if (this.group?.controls[this.name]?.value !== 0 && !this.disabled) this.group?.controls[this.name]?.markAsDirty();
      this.group?.controls[this.name].setValue(0);
      this.inputDataModel.currentValue = null;
      this.focusOutFunction(null);
      this.cd.markForCheck();
      return;
    }
    if (
      !this.group?.controls[this.name]?.value &&
      this.group?.controls[this.name]?.value === 0 &&
      (!value || value === 0) &&
      isNullOrUndefined(this.inputDataModel.currentValue)
    )
      if (value.toString().indexOf("_") > -1) {
        value = value.replace(/\_/g, "").replace(/\:/g, "");
      }
    if (this.inputDataModel.currentValue?.toString()?.indexOf("_") > -1) {
      this.inputDataModel.currentValue = this.inputDataModel.currentValue.replace(/\_/g, "").replace(/\:/g, "");
    }
    if (!this.f[this.name]?.value && this.f[this.name]?.value === 0 && (!value || value === 0) && isNullOrUndefined(this.inputDataModel.currentValue))
      return;
    if (this.textType === "number" && this.withComma) this.textType = "currency";
    if (
      this.textType === "currency" &&
      this.inputDataModel.currentValue &&
      this.group?.controls[this.name]?.value ===
        this.persianService.toEnglishNumber(this.inputDataModel.currentValue.toString().replace(/,/g, "")).toString()
    )
      return;
    if (this.textType !== "currency" && this.inputDataModel.currentValue === this.group?.controls[this.name]?.value) return;

    if ((this.textType === "currency" || this.textType == "number") && value) {
      let v = value;
      if (typeof value !== "string") {
        v = value.toString();
      }
      const number = this.persianService.toEnglishNumber(v.replaceAll(",", ""));
      //return if value have not correct character
      if (isNaN(+number) || number.toString().includes("e+")) {
        this.setLastValue();
        return;
      }
    }

    if (this.textType === "decimal") {
      this.handleDecimal(value);
      return;
    }

    if (this.textType === "currency" && value) {
      if (this.withComma) {
        this.inputDataModel.currentValue =
          value && value !== ""
            ? this.persianService.toPersianNumber(
                formatNumber(Number(this.persianService.toEnglishNumber(value.toString().replace(/,/g, ""))), "en-US", "1.0-0")
              )
            : "";
      } else {
        this.inputDataModel.currentValue = this.persianService.toPersianNumber(value);
      }
      this.inputDataModel.FormControlValue = this.persianService.toEnglishNumber(value.toString().replace(/,/g, ""));
      if (this.group?.controls[this.name]?.value !== this.persianService.toEnglishNumber(value.toString().replace(/,/g, "")) && !this.disabled)
        this.group?.controls[this.name].markAsDirty();
      this.group?.controls[this.name].setValue(this.persianService.toEnglishNumber(value.toString().replace(/,/g, "")));
    } else {
      if (this.textType === "number" || this.textType === "custom") {
        this.textType = "custom";
        this.inputDataModel.currentValue = value ? JSON.parse(JSON.stringify(this.persianService.toPersianNumber(value))) : value;
        this.inputDataModel.FormControlValue = value ? JSON.parse(JSON.stringify(this.persianService.toEnglishNumber(value))) : value;
        if (this.group?.controls[this.name]?.value !== this.inputDataModel.FormControlValue && !this.disabled)
          this.group?.controls[this.name].markAsDirty();
        this.group?.controls[this.name].setValue(this.inputDataModel.FormControlValue);
      } else {
        this.inputDataModel.currentValue = value
          ? JSON.parse(JSON.stringify(this.persianService.toPersianNumber(CorrectYeKeService.getCorrectYeKe(value))))
          : value;
        this.inputDataModel.FormControlValue = value
          ? JSON.parse(JSON.stringify(this.persianService.toEnglishNumberString(CorrectYeKeService.getCorrectYeKe(value))))
          : value;
        if (this.group?.controls[this.name]?.value !== this.inputDataModel.FormControlValue && !this.disabled)
          this.group?.controls[this.name].markAsDirty();
        this.group?.controls[this.name].setValue(this.inputDataModel.FormControlValue);
      }
    }
    setTimeout(() => {
      this.cd.markForCheck();
    }, 10);
    this.onChange(this.group?.controls[this.name]?.value);
    if (isInputValue) this.oninput.emit(this.group?.controls[this.name]?.value);
  }

  inputValueCustomizeChange() {
    if (this.group?.controls) this.getInputValue(this.group?.controls[this.name]?.value);
  }
  onEnterKeyDown(event: any) {
    if (this.group?.controls[this.name]?.value) {
      this.onEnter.emit(this.group?.controls[this.name]?.value);
    } else this.onEnter.emit();
  }
  onIconClick() {
    this.iconClick.emit();
    this.onPasswordClick();
    this.cd.markForCheck();
  }

  onExternalIconClick() {
    this.externalIconClick.emit();
    this.cd.markForCheck();
  }
  onRightIconClick() {
    this.rightIconClick.emit();
    this.cd.markForCheck();
  }
  onClear() {
    this.getInputValue(null);
    this.clear.emit();
  }
  numberOnly(event): boolean {
    if (
      ((this.textType != "number" && this.textType != "custom" && this.textType != "currency") ||
        this.isDecimal === false ||
        Boolean(this.isDecimal) === false) &&
      !this.isNumberOnly
    )
      return true;
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 44) {
      if (this.isFloat && (charCode == 46 || charCode == 47)) {
        return true;
      }
      return false;
    }
    return true;
  }
  changeEvent($event) {
    this.change.emit($event);
  }

  private setLastValue() {
    this.inputDataModel.FormControlValue = this.group?.controls[this.name]?.value;
    this.group?.controls[this.name].setValue(this.group?.controls[this.name]?.value);
    this.inputDataModel.currentValue = this.group?.controls[this.name]?.value;
    this.group?.controls[this.name].markAsDirty();
    if (this.inpElement && this.inpElement.nativeElement) {
      this.inpElement.nativeElement.value = this.group?.controls[this.name]?.value;
    }

    this.cd.markForCheck();
  }

  private onPasswordClick() {
    if (this._isPassword) {
      if (this.textType === "password") {
        this.textType = "text";
        this.icon = "icon-visibility_off-o";
      } else {
        this.textType = "password";
        this.icon = "icon-visibility-o";
      }
    }
  }

  private handleDecimal(value: any) {
    const isValidValue = this.isValidDecimalValue(value);
    if (!isValidValue && value !== "-" && value !== "") {
      this.setLastValue();
      return;
    }
    this.inputDataModel.currentValue = value
      ? JSON.parse(JSON.stringify(this.persianService.toPersianNumber(CorrectYeKeService.getCorrectYeKe(value))))
      : value;
    this.inputDataModel.FormControlValue = value
      ? JSON.parse(JSON.stringify(this.persianService.toEnglishNumberString(CorrectYeKeService.getCorrectYeKe(value))))
      : value;
    const ctrl = this.group?.controls[this.name];
    if (ctrl?.value !== this.inputDataModel.FormControlValue && !this.disabled) ctrl.markAsDirty();
    ctrl.setValue(this.inputDataModel.FormControlValue);
    this.onChange(this.group?.controls[this.name]?.value);
  }

  isValidDecimalValue(value: string): boolean {
    // Regular expression to match valid numbers (including negative and decimal numbers)
    const regex = /^-?\d+(\.\d+)?$/;
    // Test if the input value matches the regex
    return regex.test(value);
  }
}
